<div class="page main d-flex flex-column justify-content-start" *ngIf="user$ | async" fadeIn="500" [fadeInDelay]="200">

  <app-toolbar type="menu" class="above-tab" [leftAction]="(backButtonCaption$ | async)!" (backClick)="back()">
    <h3>Estimate</h3>
  </app-toolbar>

  <app-mobile-toolbar class="under-tab" [showMenu]="true" [leftAction]="(backButtonCaption$ | async)!" (backClick)="back()"></app-mobile-toolbar>

  <ng-container *ngIf="!(largeScreen$ | async)" [ngTemplateOutlet]="tabs"></ng-container>

  <div class="d-flex h-100 container main-layout" *ngIf="estimate$ | async let estimate">

    <div class="estimate-main flex-fill" scroll (scrollPosition)="scrollPosition = $event"
         [class.hide-tab]="!(showInfo$ | async)"
    >
      <div style="min-height: unset">
        <div class="close-and-workflow-bar">
          <app-progress-bar [workflowId]="estimate.workflowId" active="estimate"></app-progress-bar>
        </div>

        <app-missing-nuvei *ngIf="showNuveiNotConnectedBanner$ | async"></app-missing-nuvei>

        <app-version-picker
            [versions]="(estimateVersions$ | async)!"
            [selectedVersionId]="(currentEstimateVersionId$ | async)!"
            (versionSelected)="setCurrentVersion($any($event))"
            [actions]="actions"
            (actionClick)="handleVersionPickerAction($event)"
            type="Estimate"
            [estimate]="estimate"
            *ngIf="!preview"
            [disableActions]="(readonly$ | async)!"
        ></app-version-picker>

        <ng-container *ngIf="currentEstimateVersion$ | async let currentEstimateVersion">
          <app-workflow-prepared [workflow]="estimate"
                                 [currentWorkflowVersion]="currentEstimateVersion"
                                 *ngIf="currentEstimateVersion.status === 'created' && !preview"
                                 [updateSnackbarMessage]="'Estimate updated'"
                                 [updateFunction]="clientUpdateFunction"
                                 [readonly]="(readonly$ | async)!"
          ></app-workflow-prepared>

          <app-estimate-editable [scrollPosition]="scrollPosition"
                                 [estimate]="estimate"
                                 (editableInFocus)="differentInFocus$.next($event)"
                                 [currentEstimateVersion]="currentEstimateVersion"
                                 *ngIf="currentEstimateVersion.status === 'created' && !preview"
                                 [readonly]="(readonly$ | async)!"
          ></app-estimate-editable>

<!--          <app-estimate-preview-and-send *ngIf="preview" [estimate]="estimate"-->
<!--                                         [currentEstimateVersion]="currentEstimateVersion"-->
<!--          ></app-estimate-preview-and-send>-->

<!--          <app-estimate-preview-and-send *ngIf="currentEstimateVersion.status !== 'created' && !preview"-->
<!--                                         [estimate]="estimate" [currentEstimateVersion]="currentEstimateVersion"-->
<!--                                         [sentMode]="true"-->
<!--          ></app-estimate-preview-and-send>-->

          <app-estimate-preview-and-send *ngIf="currentEstimateVersion.status !== 'created' || preview"
                                         [estimate]="estimate" [currentEstimateVersion]="currentEstimateVersion"
                                         [sentMode]="!preview"
          ></app-estimate-preview-and-send>
        </ng-container>
      </div>

      <ng-container *ngIf="currentEstimateVersion$ | async let currentEstimateVersion">
        <ng-container *ngIf="{ value: differentInFocus$ | async } as differentInFocus">
          <app-estimate-actions [estimate]="estimate"
                                [currentEstimateVersion]="currentEstimateVersion"
                                (setCurrentEstimateVersionId)="currentEstimateVersionId$.next($event);"
                                (previewEvent)="preview = $event"
                                [preview]="preview"
                                (sendEvent)="sendEstimateVersion(estimate, currentEstimateVersion)"
                                [sendLoading]="sendLoading"
                                *ngIf="currentEstimateVersion?.items?.length! > 0"
                                [depositFocused]="differentInFocus.value ?? false"
                                [disableActions]="(readonly$ | async)!"
          ></app-estimate-actions>
        </ng-container>
      </ng-container>
    </div>

    <div *ngIf="(largeScreen$ | async) || !(showInfo$ | async)" class="side-panel-wrap" (click)="sidePanelClick($event)">
      <ng-container *ngIf="largeScreen$ | async" [ngTemplateOutlet]="tabs"></ng-container>
      
      <div class="notes-wrap" [class.d-none]="!(showNotes$ | async)">
        <app-notes
          class="notes"
          [workflowId]="(params$ | async)!.workflowId"
          [businessId]="(businessId$ | async)!"
          [currentUser]="(currentUser$ | async)!"
          [isModal]="false"
          [showJobType]="true"
          [showOverlayImageViewer]="true"
          from="Estimate"
          [readonly]="(readonly$ | async)!"
        ></app-notes>
      </div>

      <div class="chat-wrap h-100" *ngIf="showChat$ | async">
        <app-chat #chat
          [chat]="chat$ | async"
          [showDocLink]="false"
          [workflow]="{ id: (params$ | async)!.workflowId, docType: 'estimate' }"
        ></app-chat>
      </div>
    </div>
    
  </div>

  <ng-template #tabs>
    <app-tabs
      [class.app-tabs]="!(largeScreen$ | async)"
      linePosition="bottom"
      alignment="center"
      [tabs]="(tabs$ | async)!"
      [activeTab]="(selectedTab$ | async)!"
      (onTabSelect)="setActiveTab($event)"
      [redDots]="(tabsRedDots$ | async)!"
    ></app-tabs>
  </ng-template>

</div>
